export const LOCAL_STORAGE_CONSTANTS = {
  ACCESS_TOKEN: 'accessToken',
  STORES: 'stores',
  COUNTIES: 'counties',
};

export const API_URL = {
  COUNTIES: 'localization/county/full',
  LOGIN: 'auth/login',
  CREATE_CARD: 'api/customer/membership/professional',
};
